const variants = {
  warning: {
    background: "#ff9d0019",
    borderColor: "warning",
  },
  danger: {
    background: "#cc000019",
    borderColor: "failure",
  },
  success: {
    background: "rgba(49, 208, 170, 0.1)",
    borderColor: "success",
  },
};

export default variants;
